import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../common/Button";
import { AssociateDeviceForm } from "./AssociateDeviceForm";
import { setupSummaryPath } from "./setupRoutes";
import { SetupLayout } from "./SetupLayout";
import { useBreedingBuildings } from "./useBreedingBuildings";

// Clé passée en prop à SetupLayout, invisible du parser sans ce marqueur.
// i18n.t("setup-devices-title")
export const SetupDevicesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const breedingId = Number(useParams().breedingId);

  const { buildings } = useBreedingBuildings(breedingId);
  const [associated, setAssociated] = useState<string[]>([]);

  return (
    <SetupLayout
      step={3}
      breedingId={breedingId}
      titleKey="setup-devices-title"
    >
      <AssociateDeviceForm
        // Valeur ignorée par le backend, qui impose l'entreprise de la session.
        companyId={0}
        buildings={buildings}
        associated={associated}
        onAssociated={(uuid) => setAssociated((prev) => [...prev, uuid])}
        hint={t("setup-device-hint")}
      />

      <div className="mt-6">
        <Button
          size="full"
          onClick={() => navigate(setupSummaryPath(breedingId))}
        >
          {associated.length > 0 ? t("setup-next") : t("setup-devices-later")}
        </Button>
      </div>
    </SetupLayout>
  );
};
